<div class="ui-g ui-fluid dashboard">
  <div class="ui-g-12 ui-md-6">
    <div class="card clearfix">
      <h2>{{ 'login.changePasswordButton' | translate }}</h2>
      <br/>
      <form #f="ngForm" (ngSubmit)="onChangePasswordSubmit($event, newPasswordField, confirmNewPasswordField)">
          <input
            #newPasswordField
            name="newPasswordField"
            type="password"
            autocomplete="off"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget"
            placeholder="{{ 'login.newPasswordPlaceHolder' | translate }}"
            required
            minlength="8"
            pattern="(?=^.{8,100}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*"
          />
        <br/><br/>
          <input
            #confirmNewPasswordField
            name="confirmNewPasswordField"
            type="password"
            autocomplete="off"
            class="ui-inputtext ui-corner-all ui-state-default ui-widget"
            placeholder="{{ 'login.newPasswordConfirmationPlaceHolder' | translate }}"
            required
            minlength="8"
            pattern="(?=^.{8,100}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*"
          />
        <br/><br/>
          <button type="submit" pButton icon="fa fa-check" iconPos="left" label="{{ 'login.changePasswordButton' | translate }}"></button>
      </form>
    </div>
  </div>
  <div class="ui-g-12 ui-md-6">
    <div class="card clearfix">
      <h2>{{ 'profile.changeEmailButton' | translate }}</h2>
      <br/>
      <form #f="ngForm" (ngSubmit)="onChangeEmailSubmit($event, newEmailField)">
        <input
          #newEmailField
          name="newEmailField"
          type="email"
          autocomplete="off"
          class="ui-inputtext ui-corner-all ui-state-default ui-widget"
          placeholder="{{ 'profile.newPasswordField' | translate }}"
          required
        />
        <br/><br/>
        <button type="submit" pButton icon="fa fa-check" iconPos="left" label="{{ 'profile.changeEmailButton' | translate }}"></button>
      </form>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/profile/profile.html